<template>
  <Modal :value="modalProductIsOpen" :onClose="toggleModalProduct">
    <b-row sm="9">
      <b-col>
        <h3>
          {{ productOfPurchaseOnFiscalEdit.productData.description }}
        </h3>
      </b-col>
    </b-row>
    <div class="mt-3 tabs-two-rows">
      <b-tabs
        active-nav-item-class="font-weight-bold"
        content-class="mt-3"
        align="center"
        v-model="tabIndex"
      >
        <b-tab active :title-link-class="linkClass(0)">
          <template #title>
            <b-spinner v-if="loadingTabProduct" type="border" small />
            Produto
          </template>
          <ProductTab ref="productTab" />
        </b-tab>
        <b-tab :title-link-class="linkClass(1)">
          <template #title>
            <b-spinner v-if="false" type="border" small />
            ICMS ST
          </template>
          <STTab ref="stTab" />
        </b-tab>
        <b-tab :title-link-class="linkClass(2)">
          <template #title>
            <b-spinner v-if="loadingTabPurchase" type="border" small />
            ICMS/IPI
          </template>
          <IcmsIpiTab ref="icmsIpiTab" />
        </b-tab>
        <b-tab :title-link-class="linkClass(3)">
          <template #title>
            <b-spinner v-if="loadingTabPurchase" type="border" small />
            PIS/COFINS
          </template>
          <PisCofinsTab ref="pisCofinsTab" />
        </b-tab>
        <b-tab :title-link-class="linkClass(4)">
          <template #title>
            <b-spinner v-if="loadingTabPurchase" type="border" small />
            IBS/CBS
          </template>
          <IBSCBS ref="IBSCBSTab" @onChangeCClassTrib="onChangeCClassTrib" />
        </b-tab>
        <b-tab :title-link-class="linkClass(5)">
          <template #title>
            <b-spinner v-if="loadingTabPurchase" type="border" small />
            IBS UF
          </template>
          <IBSUF ref="IBSUFTab" :canEditDiferimento="canEditDiferimento" />
        </b-tab>
        <b-tab :title-link-class="linkClass(6)">
          <template #title>
            <b-spinner v-if="loadingTabPurchase" type="border" small />
            IBS Mun
          </template>
          <IBSMun ref="IBSMunTab" :canEditDiferimento="canEditDiferimento" />
        </b-tab>
        <b-tab :title-link-class="linkClass(7)">
          <template #title>
            <b-spinner v-if="loadingTabPurchase" type="border" small />
            CBS
          </template>
          <CBS ref="CBSTab" :canEditDiferimento="canEditDiferimento" />
        </b-tab>
        <b-tab :title-link-class="linkClass(8)" v-if="showTribRegular">
          <template #title>
            <b-spinner v-if="loadingTabPurchase" type="border" small />
            Trib Regular
          </template>
          <TribRegular ref="TribRegularTab" @onChangeCClassTribReg="onChangeCClassTribReg" />
        </b-tab>
        <b-tab :title-link-class="linkClass(9)" v-if="showCredPresOper">
          <template #title>
            <b-spinner v-if="loadingTabPurchase" type="border" small />
            Cred Presumido
          </template>
          <CredPresOper ref="CredPresOperTab" />
        </b-tab>
        <b-tab :title-link-class="linkClass(10)">
          <template #title>
            <b-spinner v-if="loadingTabPurchase" type="border" small />
            IS
          </template>
          <IS ref="ISTab" />
        </b-tab>
      </b-tabs>
    </div>
    <br />
    <b-row align="center">
      <b-col>
        <Button type="cancel" @click="toggleModalProduct()">
          <Close class="mb-1" title="Cancelar" /> Cancelar
        </Button>
        <Button @click="handleSave()" type="success">Salvar</Button>
      </b-col>
    </b-row>
  </Modal>
</template>

<script>
import { Modal } from '@/components';
import { mapActions, mapGetters, mapState } from 'vuex';
import { Button } from '@/components/Form';
import { CalcTypesPurchaseEnum } from '@/modules/Fiscal/enums/CalcTypesEnum';
import Close from 'vue-material-design-icons/Close';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import STTab from './Tabs/STTab.vue';
import IcmsIpiTab from './Tabs/IcmsIpiTab.vue';
import PisCofinsTab from './Tabs/PisCofinsTab.vue';
import IBSCBS from './Tabs/IBSRegime/IBSCBS.vue';
import IBSUF from './Tabs/IBSRegime/IBSUF.vue';
import IBSMun from './Tabs/IBSRegime/IBSMun.vue';
import TribRegular from './Tabs/IBSRegime/TribRegular.vue';
import CredPresOper from './Tabs/IBSRegime/CredPresOper.vue';
import CBS from './Tabs/IBSRegime/CBS.vue';
import IS from './Tabs/IBSRegime/IS.vue';
import ProductTab from './Tabs/ProductTab.vue';
import * as editParser from '../../../parsers/edit-product';
import * as saveParser from '../../../parsers/save-product';
import { defaultIBSTaxRegimeProductState } from '../../../store/state';

export default {
  name: 'modalFiscalProduct',
  mixins: [FormatMixin],
  components: {
    Modal,
    STTab,
    IcmsIpiTab,
    PisCofinsTab,
    IBSCBS,
    IBSUF,
    IBSMun,
    CBS,
    TribRegular,
    CredPresOper,
    IS,
    Button,
    ProductTab,
    Close,
  },
  data() {
    return {
      tabIndex: 0,
      cClassTrib: null,
      cClassTribReg: null,
      canEditDiferimento: false,
      showTribRegular: true,
      showCredPresOper: true,
      arrTabs: [
        'productTab',
        'stTab',
        'icmsIpiTab',
        'pisCofinsTab',
        'IBSCBSTab',
        'IBSUFTab',
        'IBSMunTab',
        'CBSTab',
        'TribRegularTab',
        'CredPresOperTab',
        'ISTab',
      ],
    };
  },
  computed: {
    ...mapState('purchase', ['purchase', 'products', 'productOfPurchaseOnFiscalEdit']),
    ...mapState('componentsPurchase', [
      'modalProductIsOpen',
      'loadingTabProduct',
      'loadingTabPurchase',
    ]),
    ...mapState('product', ['productInventory']),
    ...mapState('ibsRegime', ['classTribIBSCBSCollection', 'CSTIBSCBSCollection']),
    ...mapState('client', ['client']),
    ...mapGetters('purchase', ['decimalConfiguration']),
  },
  async mounted() {
    if (!this.classTribIBSCBSCollection.length) {
      this.setLoadingTabPurchase(true);
      await this.setIbsRegimeCodesCollection();
      this.setLoadingTabPurchase(false);
    }
  },
  methods: {
    ...mapActions('purchase', [
      'totalCalcPurchase',
      'setProductOfPurchaseOnFiscalEdit',
      'setProductOnPurchaseCollection',
      'setUnitOfMeasureById',
    ]),
    ...mapActions('componentsPurchase', ['toggleModalProduct', 'setLoadingTabPurchase']),
    ...mapActions('ibsRegime', ['getIbsTaxRegimeAliquots']),
    ...mapActions('ibsRegime', ['setIbsRegimeCodesCollection']),
    isValidProduct() {
      this.$refs.productTab.$v.$touch();
      this.$refs.stTab.$v.$touch();
      return !this.arrTabs.some((e) => {
        if (this.$refs[e]?.$v?.$error) {
          return true;
        }
        return false;
      });
    },
    async handleSave() {
      if (!this.isValidProduct()) return false;

      const { productData } = saveParser.productTabInformationToSave(
        this.productOfPurchaseOnFiscalEdit,
      );
      const { fiscal } = saveParser.fiscalInformationToSave(this.productOfPurchaseOnFiscalEdit);
      const params = {
        productOfPurchaseOnFiscalEdit: {
          ...this.productOfPurchaseOnFiscalEdit,
          productData: { ...productData },
          fiscal: { ...fiscal },
        },
        products: this.products,
      };

      await this.setProductOnPurchaseCollection(params);
      await this.totalCalcPurchase({
        calcTypes: [
          CalcTypesPurchaseEnum.TOTAL_ATTRIBUTES,
          CalcTypesPurchaseEnum.TOTAL_COMMON,
          CalcTypesPurchaseEnum.TOTAL_DESC_BASED_ON_ITEM,
          CalcTypesPurchaseEnum.TOTAL_NF,
          CalcTypesPurchaseEnum.TOTAL_TAX_REGIME,
        ],
      });
      await this.toggleModalProduct();
      return this.$alert.success('Informações salvas!');
    },
    linkClass(idx) {
      if (this.$refs[this.arrTabs[idx]]?.$v?.$error) return ['text-danger'];
      if (this.tabIndex === idx) return ['color-default'];
      return ['text-muted'];
    },
    async onChangeCClassTrib(selectedClassTribIBSCBS) {
      this.cClassTrib = selectedClassTribIBSCBS;
      await this.changeIbsTaxRegimeValues();
    },
    async onChangeCClassTribReg(selectedClassTribIBSCBSReg) {
      this.cClassTribReg = selectedClassTribIBSCBSReg;
      await this.changeIbsTaxRegimeValues();
    },
    setZeroedValues() {
      this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.cClassTrib = null;
      this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.CST = null;
      this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.vBC = 0;
      this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.vIBS = 0;
      this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IBSUF = {
        ...this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IBSUF,
        ...defaultIBSTaxRegimeProductState().IBSUF,
      };
      this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IBSMun = {
        ...this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IBSMun,
        ...defaultIBSTaxRegimeProductState().IBSMun,
      };
      this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.CBS = {
        ...this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.CBS,
        ...defaultIBSTaxRegimeProductState().CBS,
      };
      this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gTribRegular = {
        ...this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gTribRegular,
        ...defaultIBSTaxRegimeProductState().gTribRegular,
      };
      this.clearGCredPresOper();
      this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IS = {
        ...this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IS,
        ...defaultIBSTaxRegimeProductState().IS,
      };
    },
    async changeIbsTaxRegimeValues() {
      this.showTribRegular = this.cClassTrib?.ind_gTribRegular ?? false;
      this.showCredPresOper = this.cClassTrib?.ind_gCredPres ?? false;

      const cMun = this.client.addressCollection?.[0]?.zipCode?.city?.code ?? '';
      const cUF = this.client.addressCollection?.[0]?.zipCode?.city?.state?.code ?? '';

      const cClassTribCode = this.cClassTrib?.codigo ?? '';
      const cClassTribRegCode = this.cClassTribReg?.codigo ?? '';

      if (!cClassTribCode) {
        this.canEditDiferimento = false;
        return this.setZeroedValues();
      }

      const aliquots = await this.getIbsTaxRegimeAliquots({
        cMun,
        cUF,
        cClassTrib: cClassTribCode,
        cClassTribReg: cClassTribRegCode,
      });

      const cst = cClassTribCode?.substring(0, 3) ?? null;
      const cstReg = cClassTribRegCode?.substring(0, 3) ?? null;

      this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime = {
        ...this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime,
        CST: cst,
        CBS: {
          ...this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.CBS,
          pCBS: aliquots.CBS.pCBS,
          pRedAliq: this.cClassTrib?.reducaoCBS ?? 0,
          pAliqEfet: aliquots.CBS.pAliqEfet,
        },
        IBSMun: {
          ...this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IBSMun,
          pIBSMun: aliquots.IBSMun.pIBSMun,
          pRedAliq: this.cClassTrib?.reducaoIBS ?? 0,
          pAliqEfet: aliquots.IBSMun.pAliqEfet,
        },
        IBSUF: {
          ...this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IBSUF,
          pIBSUF: aliquots.IBSUF.pIBSUF,
          pRedAliq: this.cClassTrib?.reducaoIBS ?? 0,
          pAliqEfet: aliquots.IBSUF.pAliqEfet,
        },
        gTribRegular: {
          ...this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gTribRegular,
          CSTReg: cstReg,
          pAliqEfetRegCBS: aliquots.tribReg.pAliqEfetRegCBS,
          pAliqEfetRegIBSMun: aliquots.tribReg.pAliqEfetRegIBSMun,
          pAliqEfetRegIBSUF: aliquots.tribReg.pAliqEfetRegIBSUF,
        },
      };

      const cstIbsCbs = this.CSTIBSCBSCollection.find((e) => e.codigo === cst);

      this.canEditDiferimento = cstIbsCbs?.ind_gDif ?? false;

      return this.clearValuesByIndicators();
    },
    clearValuesByIndicators() {
      const indGTribRegular = this.cClassTrib?.ind_gTribRegular ?? false;
      const indGCredPres = this.cClassTrib?.ind_gCredPres ?? false;

      if (!indGTribRegular || !this.cClassTribReg?.codigo) {
        this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gTribRegular = {
          ...this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gTribRegular,
          ...defaultIBSTaxRegimeProductState().gTribRegular,
        };
      }

      if (!indGCredPres) {
        this.clearGCredPresOper();
      }

      if (!this.canEditDiferimento) {
        this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IBSUF.pDif = 0;
        this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IBSMun.pDif = 0;
        this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.CBS.pDif = 0;
        this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IBSUF.vDif = 0;
        this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IBSMun.vDif = 0;
        this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.CBS.vDif = 0;
      }
    },
    clearGCredPresOper() {
      this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gCredPresOper.vBCCredPres = 0;
      this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gCredPresOper.cCredPres = null;
      this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gCredPresOper.gIBSCredPres = {
        ...this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gCredPresOper.gIBSCredPres,
        ...defaultIBSTaxRegimeProductState().gCredPresOper.gIBSCredPres,
      };
      this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gCredPresOper.gCBSCredPres = {
        ...this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gCredPresOper.gCBSCredPres,
        ...defaultIBSTaxRegimeProductState().gCredPresOper.gCBSCredPres,
      };
    },
  },
  watch: {
    async modalProductIsOpen() {
      if (!this.modalProductIsOpen) {
        return;
      }

      const { fiscal } = this.productOfPurchaseOnFiscalEdit;
      const { productData } = editParser.productTabInformationToEdit(
        this.productOfPurchaseOnFiscalEdit,
        this.decimalConfiguration,
      );
      const { values } = editParser.fiscalValuesToEdit(this.productOfPurchaseOnFiscalEdit);

      await this.setProductOfPurchaseOnFiscalEdit({
        ...this.productOfPurchaseOnFiscalEdit,
        productData: { ...productData },
        fiscal: {
          ...fiscal,
          values: { ...values },
        },
      });

      this.cClassTrib =
        this.classTribIBSCBSCollection.find(
          (e) => e.codigo === this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.cClassTrib,
        ) || null;
      this.cClassTribReg =
        this.classTribIBSCBSCollection.find(
          (e) =>
            e.codigo ===
            this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gTribRegular.cClassTribReg,
        ) || null;

      await this.changeIbsTaxRegimeValues();
    },
  },
};
</script>

<style scoped>
.tabs-two-rows ::v-deep .nav-tabs {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}

.tabs-two-rows ::v-deep .nav-tabs .nav-item:nth-child(n + 5) {
  margin-top: 0.5rem;
}
</style>
